export default "__VITE_ASSET__0393fc33__"